import type { ProductMediaTypeEnum, SimplifiedImageJSON } from '../../types/algolia';
import type { Maybe } from 'graphql/jsutils/Maybe';

import { ALLOWED_SWATCH_IMAGES } from '../../components/shared/recommendations/tile/tileImage/constants';

/**
 * searches profiles from left(most priority) to right(fallbacks in descending priority) and returns the first found profile image
 *
 * @param images map containing images in which to search for
 * @returns a function bound to passed images map, which will search first image matching the passed profile config
 */
export const findProfileImage =
  <T>(images: Map<Maybe<string>, Maybe<T>>) =>
  /**
   * @param profiles image profile list, example `'M01|E01|F01'`
   * @returns image url if any will match the given profile
   */
  (profiles: Maybe<string>) =>
    profiles
      ?.split('|')
      ?.map(profile => images.get(profile.trim()))
      ?.find(image => image !== undefined && image !== null);

export const checkImageSwatchAvailability = (images: SimplifiedImageJSON) =>
  ALLOWED_SWATCH_IMAGES.some(x => images[x as ProductMediaTypeEnum]?.url);
